export default {
    baseURL: '/api/', // 'http://localhost:8088/',
    // timeout: 5000,
    timeout: 1200000,
    retry: 1, // 超时失败时重连一次
    retryDelay: 1000,
    withCredentials: true, // default
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    commonIp: 'https://datago-bj.fupin832.com'
};
